import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService, ILogHistoryV1 } from 'src/app/tools/api.service';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';

@Component({
  selector: 'app-localaccounthistory',
  templateUrl: './localaccounthistory.component.html',
  styleUrls: ['./localaccounthistory.component.scss']
})
export class LocalaccounthistoryComponent implements OnInit, OnDestroy {
  historySub:any;
  history: ILogHistoryV1[];
  pageSize = 10;
  currentPage = 0;
  totalSize = 0;
  isLoading:boolean = false;

  constructor(private apiService : IxellAPIService, private headerService : HeaderService) { }

  ngOnInit() {
    Utils.deleteStorageData();
    this.getHistory(10,0);
    // Pour afficher la flèche de retour
    this.headerService.changeCanBack(true);
    this.headerService.changeTitle("IxellWebLab");
    this.headerService.changeLogo(null);
  }

  public handlePage(e: any) {
    this.history = [];
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.getHistory(e.pageSize, e.pageIndex	* 10);
  }

  getHistory(limit:number, offset:number){   
    this.isLoading = true; 
    this.historySub = this.apiService.getCompleteHistory(limit, offset).subscribe(data => {
      this.history = data.history;
      this.totalSize = data.totalCount;
      this.isLoading = false; 
    }, error => {
      if (this.historySub != null) this.historySub.unsubscribe();
      console.log(error);
      this.isLoading = false; 
    })
  }

  ngOnDestroy(){
    if (this.historySub != null) this.historySub.unsubscribe();
  }

}
